import React from 'react';
import { substitute } from '../../services/stringsubstitutions';
import { buildClassName, deepCopy } from '../forms/formFunctions';

export const ContainerDynamic = ({ formGenerator, field, additional, controller, collectionStack }) => {

    if(field.tag == 'input') debugger;
    if(field.content != null && Array.isArray(field.content)) {
        field.items = field.content;
        field.content = null;
    }

    var createRows = () => {
        return field.items.map((fld, sectionIndex) => {
            const uiItem = formGenerator.createControls(additional.addToValidationFunc, fld, '', collectionStack);
            if (field.childTag == null) return <>{uiItem}</>;

            var childStyles = {
                className: buildClassName(formGenerator, field, null, field.childClass, collectionStack),
                style: field.childStyles,
                ...field.attributes,
            };

            var child = React.createElement(field.childTag, childStyles, uiItem);
            return <>{child}</>;
        });
    };

    var rows = null;
    if (field.header != null && typeof field.header == 'string') {
        var copyStack = deepCopy(collectionStack);
        copyStack.reverse();

        

        if(field?.settings?.attributes?.originalReplacements)
            delete field.settings.attributes.originalReplacements;
  

        var styles = {
            className: buildClassName(formGenerator, field, null, field.class, collectionStack),
            style: field.styles,
            // ...field.attributes,
            ...field.settings?.attributes,
        };

        var header = substitute(field.header, formGenerator.props.controller, [...copyStack, formGenerator.getFormData()]);
        var item = <>{header}</>;
        var child = React.createElement(field.tag, styles, item);
        return <>{child}</>;
    } else if (field.content) {
        if (field.content === '') return <></>;

        var fs = {
            type: 'formSection',
            key: field.content,
        };

        // if (formGenerator.props.eventType === 'UPDATE_CONFIGS') field.items = [];
        if (field.items.length === 0) {
            field.items.items = [];
            field.items.push(fs);
        }

        rows = createRows();
    } else {
        if (field.header != null) {
            field.items = [field.header];
            field.header = null;
        }

        if (field.items) {
            rows = createRows();
        } else rows = null;
    }

    var parentStyles = {
        className: buildClassName(formGenerator, field, 'dynamic-' + field.tag, field.class, collectionStack),
        style: field.styles,
        ...field.attributes,
        ...field.settings?.attributes,
    };

    if(field.events?.onClick != null) {
        parentStyles = {
            ...parentStyles,
            onClick: (e) => {
                if(field.events?.onClick != null){
                    var event  = typeof field.events.onClick === 'string' && field.events.onClick.indexOf('${') > -1
                        ? substitute(field.events.onClick, formGenerator.props.controller, [...collectionStack, formGenerator.getFormData()])
                        : field.events.onClick;
                    
                    formGenerator.runActions(
                        field,
                        event,
                        field.settings.value,
                        formGenerator.getFormData(),
                        copyStack,
                        false,
                        e
                    );     
                }           
            }
        }
    }


    let retVal = React.createElement(field.tag, parentStyles, rows);
    return retVal;
};
